import React, { createContext, useContext, useMemo } from 'react';
import type { FC, PropsWithChildren } from 'react';
import { PHOTO_GRID_STATE_KEY } from './constants';

const PhotoGridStoreContext = createContext<{ productId: string }>({ productId: '' });

export const PhotoGridStoreProvider: FC<PropsWithChildren<{ productId: string }>> = ({
    productId,
    children,
}) => {
    const value = useMemo(() => ({ productId }), [productId]);
    return (
        <PhotoGridStoreContext.Provider value={value}>{children}</PhotoGridStoreContext.Provider>
    );
};

export const usePhotoGridProductId = (): string => useContext(PhotoGridStoreContext).productId;

export const usePhotoGridQueryKey = (): string[] => [PHOTO_GRID_STATE_KEY, usePhotoGridProductId()];
